import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { catchError } from 'rxjs/operators';
import { ConstantsModule } from '../../shared/constants/constants.module';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isEmptyField } from 'src/app/main/shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { UtilsSharedModule } from 'src/app/main/shared/utils/utils/utils.module';



@Injectable({
  providedIn: 'root'
})
export class RainfallActualDataService {

  serviceURL = 'http://40.118.204.142/tomcat/geoserver/NEWRM/ows';
  gisStoreName = 'NEWRM';

  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService,
    private constants: ConstantsModule,
    private utilsShared: UtilsSharedModule,
  ) { }

  getSourceListForComponent(options): Observable<any> {
    if (isNullOrUndefined(options['component'])) {
      return;
    }
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getrankwisesource', options).pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getDateRangeForComponent(component: string, source: string): Observable<any> {

    return this.http.get<any>(environment.url.PLAY_URL + 'comm/range2/' + component + '/' + source).pipe(
      catchError(this.errorHandler.handleError('Date range request for ' + component, []))
    );
  }

  getHeirarchy(options: object): Observable<any> {
    const heatMapUrl = 'locations/heirarchy';
    return this.http.post<any>(environment.url.PLAY_URL + heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('Rainfall linechart data request', []))
    );
  }

  getLocationLevelForSourceAndComponent(options: object): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getLocTypes', options).pipe(
      catchError(this.errorHandler.handleError('Locations Level for Source Data request', []))
    );
  }

  getHeatMapData(url, options: object): Observable<any> {
    const heatMapUrl = url;
    return this.http.post<any>(heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('error in Heatmap data request', []))
    );
  }

  getGeoJsonLayerData(layerName: string, filter): Observable<any> {
    let layerURL = this.serviceURL + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + this.gisStoreName + ':' + layerName + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    if (filter || filter == '')
      layerURL += '&cql_filter=' + filter;
    return this.http.get(layerURL).pipe(
      catchError(this.errorHandler.handleError('error in GeoJson data request', []))
    );
  }

  getdataGis(url, options: object, homeReservoir = false): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + url, options).pipe(
      catchError(this.errorHandler.handleError('table data request', []))
    );
  }

  fetchSource(countryUUID:any, stateUUID:any): Observable<any> {
    const heatMapUrl = 'rf/getSourcesForState/' + countryUUID + '/' + stateUUID;
    return this.http.get<any>(environment.url.OBSERVED_API_URL + heatMapUrl).pipe(
      catchError(this.errorHandler.handleError('Source Requested', []))
    );
  }

  formatdata(layer, geodata, data) {

    const component = layer.Component;
    const src = layer.SRC;
    let formatedData;
    // console.log("formatdata ::",component,src,geodata, data);
    if (component == this.constants.COMPONENT.RAINFALL)
      formatedData = this.formatRFData(geodata, data);

    return formatedData;
  }

  formatRFData(geodata, data) {
    geodata['features'].forEach(station => {

      data.forEach(element => {
        if (station['properties']['loc_uuid'] == element['uuid'])
          Object.assign(station['properties'], { 'actual': element['actual'] })
      });
    });
    return geodata;
  }


  getRFStationData(options: object): Observable<any>{
    return this.http.post < any >(environment.url.PLAY_URL + "rf/rfTrend" , options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request',[]))
    );
  }

  getKpiData(options:object): Observable < any >{
    return this.http.post < any >(environment.url.OBSERVED_API_URL + "rf/aggregated" , options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request',[]))
    );
  }

  post(postData): Observable<any> {
  postData.format ='DAILY';
    let projURL = environment.url.OBSERVED_API_URL + "rf/aggregated";
    return this.http.post<any>(projURL , postData);
  }

  getHWAccuracyData(postData): Observable<any> {
    postData.format ='DAILY';
    return this.http.post < any >(ProjConstants.OBSERVED_API_URL + "rf/aggregated" , postData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request',[]))
    );
  }
  
  getPostDataForSensor(params) {
    let postData = {
      "sDate": params.sDate,
      "eDate": params.eDate,
      "pUUID": params.locuuid,
      "pType": params.loctype,
      "format": this.getFormat(params.format),
      "cType": "RAINFALL",
      "pEUUID": params.locuuid,
      "classification": [
        "ACTUAL"
      ],
      "src": params.src,
      "aggr": params.aggr,
      "includeAllLoc": true
    }

    return postData
  }

  getFormat(format) {
    if(format == 'yyyyMMdd') {
      return 'DAILY'
    } else if(format == 'yyyyMM') {
      return 'MONTHLY'
    } else if(format == 'yyyy') {
      return 'YEARLY'
    } else {
      return 'HOURLY'
    }
  }


  getConfigForFilters(){
    let filterConfig = {
      sourceList: {
        isVisible: true,
        label:'Source of Data'
      },
      viewList: {
        isVisible: true,
        label:'Location Hierarchy'
      },
      locationTypeList: {
        isVisible: true,
        label:'Location Level'
      },
      locationList: {
        isVisible: true,
        label:'Location'
      },
      sDate: {
        isVisible: true,
        label:'Start Date'
      },
      eDate: {
        isVisible: true,
        label:'Stop Date'
      },
    }
    return filterConfig;
  }


  setRainfallcolor(value) {

    let obj;
    if (parseFloat(value) >= 60) {
      obj = {'textcolor': '#ffffff', 'bgcolor': '#0099ff'}
    }
    else if (parseFloat(value) >= 20 && parseFloat(value) < 60) {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#b9e5fb'}
    }
    else if (parseFloat(value) >= -19 && parseFloat(value) < 20) {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#90ed7d'}
    }
    else if (parseFloat(value) < -19 && parseFloat(value) > -60) {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#e9e910'}
    }
    else if (parseFloat(value) <= -60 && parseFloat(value) > -99) {
      obj = {'textcolor': '#ffffff', 'bgcolor': '#e80d0d'}
    }
    else if (parseFloat(value) == -100) {
      obj = {'textcolor': '#ffffff', 'bgcolor': '#b3b1b1'}
    }
    else {
      obj = {'textcolor': '#5e594e', 'bgcolor': '#ffffff'}
    }
    return obj;
  }

  deepClone(object:any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj :any= {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }

  getTitleForComponent(urlParams) {
    let title = null;
    if (urlParams['format'] != "HOURLY") {
      // title = this.utilsShared.gettimestepbyformat(urlParams['format']) + ' ' +
      title = 'Daily' + ' ' +
        this.utilsShared.getaggregationtypedisplay(urlParams['aggr']) + " Rainfall Information From " +
        this.utilsShared.getDateInFormatFromModelDate(this.utilsShared.getStartAndEndDatesForType(urlParams['sDate'], urlParams['eDate'], urlParams['format'])['startDate'], 'dd-mmm-yyyy') +
        " To "
        + this.utilsShared.getDateInFormatFromModelDate(this.utilsShared.getLastDayForGivenModelDate(urlParams['eDate'], this.constants.SELECTED_COMPONENT_CORRESPONDING_DATA.MAX_DATE), 'dd-mmm-yyyy') +
        ' Using ' + urlParams['src'] + ' Data'
    } else {
      // title = this.utilsShared.gettimestepbyformat(urlParams['format']) + ' ' +
      title = 'Daily' + ' ' +
        this.utilsShared.getaggregationtypedisplay(urlParams['aggr']) + " Rainfall Information From " +
        this.utilsShared.getSimpleDateAndTimeStringFor12hrs(urlParams['sDate']) +
        " To "
        + this.utilsShared.getSimpleDateAndTimeStringFor12hrs(urlParams['eDate']) +
        ' Using ' + urlParams['src'] + ' Data'
    }

    return title;
  }

  triggerAPi( postData : any){
    return this.http.post<string>(
      ProjConstants.OBSERVED_API_URL + "rainfall/triggerInterpolationAggregationForAOI",
      postData,
      { responseType: 'text' as 'json' } // Cast responseType to match TypeScript expectations
    );
    // return this.http.post < any >(ProjConstants.OBSERVED_API_URL + "rainfall/triggerInterpolationAggregationForAOI" , postData , { responseType: 'text' });
  }

  getTaskList( postData : any){
    return this.http.post < any >(ProjConstants.OBSERVED_API_URL2 + "taskmgmt/getUserTasks" , postData);
  }
}